import { Box, Text } from '@wix/design-system';
import React from 'react';
import s from './SaleTimer.scss';
import { useCurrentModule } from '../ModuleProvider';
const TimeUnit = _ref => {
  let {
    value,
    unit
  } = _ref;
  return /*#__PURE__*/React.createElement(Box, {
    direction: "vertical",
    align: "center",
    className: s.timeUnit
  }, /*#__PURE__*/React.createElement(Text, {
    className: s.timeNumber
  }, value), /*#__PURE__*/React.createElement(Text, {
    className: s.timeLabel
  }, unit));
};
export const SaleTimer = _ref2 => {
  let {
    hours,
    minutes,
    seconds,
    mobile = false
  } = _ref2;
  const module = useCurrentModule();
  const {
    t
  } = module.internals.useTranslations();
  if (mobile) {
    return /*#__PURE__*/React.createElement(Box, {
      direction: "horizontal",
      verticalAlign: "middle",
      className: s.timerMobile
    }, /*#__PURE__*/React.createElement(Text, {
      className: s.timeNumberMobile
    }, hours), /*#__PURE__*/React.createElement(Text, {
      className: s.timeSeparatorMobile
    }, ":"), /*#__PURE__*/React.createElement(Text, {
      className: s.timeNumberMobile
    }, minutes), /*#__PURE__*/React.createElement(Text, {
      className: s.timeSeparatorMobile
    }, ":"), /*#__PURE__*/React.createElement(Text, {
      className: s.timeNumberMobile
    }, seconds));
  }
  return /*#__PURE__*/React.createElement(Box, {
    direction: "horizontal",
    verticalAlign: "middle",
    className: s.timer
  }, /*#__PURE__*/React.createElement(TimeUnit, {
    value: hours,
    unit: t('premium-purchase-plan.studio_sale.countdown.hours')
  }), /*#__PURE__*/React.createElement(Text, {
    className: s.timeSeparator
  }, ":"), /*#__PURE__*/React.createElement(TimeUnit, {
    value: minutes,
    unit: t('premium-purchase-plan.studio_sale.countdown.minutes')
  }), /*#__PURE__*/React.createElement(Text, {
    className: s.timeSeparator
  }, ":"), /*#__PURE__*/React.createElement(TimeUnit, {
    value: seconds,
    unit: t('premium-purchase-plan.studio_sale.countdown.seconds')
  }));
};
//# sourceMappingURL=SaleTimer.js.map